<template>
  <fetch-body-content :page-title="pageTitle" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { getDynamicTitle } from '@/services/admin_actions/getDynamicTitle'

import FetchBodyContent from '@/components/FetchBodyContent.vue'

// Determine the page title for dynamic content routes
const route = useRoute()
const pageTitle = computed(() => getDynamicTitle(route.fullPath))

</script>

<style lang="scss">
</style>